/* Fix: newsletter popup was showing on every page view because closing it (X button, backdrop click, ESC) never set the "don't show again" cookie - only an obscure, unlabeled checkbox did, and only for 1 hour. This makes closing the popup by any means suppress it for 7 days. */
(function () {
  function bind() {
    var $ = window.jQuery;
    if (!$) return;
    var popupSubscribe = $('#popup-subscribe');
    if (!popupSubscribe.length) return;
    popupSubscribe.on('hidden.bs.modal', function () {
      var date = new Date();
      date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);
      $.cookie('popupNewLetterStatus', 'closed', { expires: date, path: '/' });
    });
  }
  if (window.jQuery) {
    bind();
  } else {
    window.addEventListener('load', bind);
  }
})();
